import React from 'react';
import './Slant.scss';

export const Slant = (props) => {
  const { color, slantDirection } = props;
  return (
    <div className={`slant ${color} ${slantDirection}`} />
  );
};
